export default "__VITE_ASSET__D9fuL1Ew__"